export interface TarotCard {
  id: number;
  name_en: string;
  name_hi: string;
  vedic_name: string;
  vedic_parallel: string;
  arcana: string;
  suit: string | null;
  orientation: string;
  keywords: string[];
  meaning: string;
  advice: string;
  image_description: string;
  element: string | null;
  vedic_element: string | null;
  vedic_graha: string | null;
  date?: string;
  spread_type?: string;
  position?: string;
}

export interface CardRef {
  id: number;
  name_en: string;
  name_hi: string;
  vedic_name: string;
  vedic_parallel: string;
  arcana: string;
  suit: string | null;
  element: string | null;
  vedic_element: string | null;
  upright: { keywords: string[]; meaning: string; advice: string };
  reversed: { keywords: string[]; meaning: string; advice: string };
}

export const SUIT_SYMBOLS: Record<string, string> = {
  wands: "🔥",
  cups: "💧",
  swords: "🌬️",
  pentacles: "🌍",
};

export const SUIT_LABELS: Record<string, string> = {
  wands: "Wands (Agni)",
  cups: "Cups (Jal)",
  swords: "Swords (Vayu)",
  pentacles: "Pentacles (Prithvi)",
};

export const RASHIS = [
  { id: "mesh", en: "Aries", hi: "मेष" },
  { id: "vrishabh", en: "Taurus", hi: "वृषभ" },
  { id: "mithun", en: "Gemini", hi: "मिथुन" },
  { id: "kark", en: "Cancer", hi: "कर्क" },
  { id: "singh", en: "Leo", hi: "सिंह" },
  { id: "kanya", en: "Virgo", hi: "कन्या" },
  { id: "tula", en: "Libra", hi: "तुला" },
  { id: "vrishchik", en: "Scorpio", hi: "वृश्चिक" },
  { id: "dhanu", en: "Sagittarius", hi: "धनु" },
  { id: "makar", en: "Capricorn", hi: "मकर" },
  { id: "kumbh", en: "Aquarius", hi: "कुम्भ" },
  { id: "meen", en: "Pisces", hi: "मीन" },
];

export function romanNumeral(n: number): string {
  const map: [number, string][] = [
    [21, "XXI"],
    [20, "XX"],
    [19, "XIX"],
    [18, "XVIII"],
    [17, "XVII"],
    [16, "XVI"],
    [15, "XV"],
    [14, "XIV"],
    [13, "XIII"],
    [12, "XII"],
    [11, "XI"],
    [10, "X"],
    [9, "IX"],
    [8, "VIII"],
    [7, "VII"],
    [6, "VI"],
    [5, "V"],
    [4, "IV"],
    [3, "III"],
    [2, "II"],
    [1, "I"],
    [0, "0"],
  ];
  for (const [val, rom] of map) {
    if (n === val) return rom;
  }
  return String(n);
}
